/** Channels (/w/:ws/agents/:agentId/channels). */
export const channels = {
  title: "Channels",
  subtitleBefore: "Where people can reach the",
  subtitleAfter: ". One brain, every channel.",
  subtitleFallback: "Where people can reach this assistant. One brain, every channel.",
  channelAnalytics: "Channel analytics",
  connectMessenger: "Connect Messenger",
  messengerConnected: "Messenger connected",
  loadError: "Channels couldn't load.",
  emptyTitle: "No channels for this assistant yet",
  emptyBody: "Channels appear here once the assistant is set up. Start with the website widget.",
  emptyCta: "Open Widget Studio",
  kpi: {
    active: "Active channels",
    activeOf: "of {{count}} available",
    conversations: "Conversations · 7 days",
    deltaUp: "+{{value}}%",
    deltaDown: "{{value}}%",
    noDelta: "No earlier data to compare",
    top: "Top channel",
    topShare: "{{pct}}% of conversations",
    none: "—",
    noConversations: "No conversations yet",
    avgResponse: "Avg first response · 7 days",
    avgResponseHint: "Across all channels",
  },
  names: {
    widget: "Website widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Facebook Messenger",
    email: "Email inbox",
    api: "REST API",
    playground: "Playground",
    slack: "Slack",
    teams: "Microsoft Teams",
  },
  status: {
    active: "Connected",
    pending: "Not set up",
    disconnected: "Not connected",
    error: "Needs attention",
    disabled: "Turned off",
  },
  enable: "Enable {{channel}}",
  toggledOn: "{{channel}} turned on",
  toggledOff: "{{channel}} turned off",
  conversations7d: "conversations · 7d",
  emails7d: "emails · 7d",
  widget: {
    domains_one: "{{count}} domain",
    domains_other: "{{count}} domains",
    noDomains: "No allowed domains yet",
    description: "Chat bubble on your website. Allowed domains and look are set in Widget Studio.",
    customize: "Customize",
  },
  webapp: {
    description: "A full-page chat on its own address — share the link anywhere.",
    domainNote: "Custom domain and SSL are managed under Settings → Domains.",
    domain: "Domain",
    open: "Open",
    openLabel: "Open the web app in a new tab",
  },
  mobile: {
    description: "Put the assistant inside your own iOS or Android app, with a few lines of code.",
    note: "Nothing to download from us.",
    guide: "Install guide",
  },
  messenger: {
    descriptionOff: "Many people message your Facebook Page first. Let the assistant reply 24/7.",
    descriptionOn: "Replying to Page messages 24/7. Handoffs appear in your Inbox with a Messenger badge.",
    connectPage: "Connect Facebook Page",
    disconnect: "Disconnect",
    estimate: "Replies within Meta's 24-hour window",
    redirecting: "Opening Facebook…",
    dialogTitle: "Connect Facebook Messenger",
    dialogBody: "Log in with the Facebook account that is an admin of your Page. We never post on your behalf.",
    stepLogin: "Log in",
    stepPage: "Pick Page",
    stepPermissions: "Permissions",
    permissionsIntro: "Sagot will request these permissions:",
    permMessaging: "Read and reply to Messenger conversations",
    permMetadata: "Subscribe to new message webhooks",
    permList: "See the Pages you manage",
    permBusiness: "Optional: also list Pages you manage through a business portfolio",
    pauseNote: "Staff can still reply from Meta Business Suite. When a staff member replies, the assistant pauses for that conversation for 12 hours.",
    continueWithFacebook: "Continue with Facebook",
    redirectNote: "You'll leave this page to sign in with Facebook, then come back here to pick your Page.",
    disconnectTitle: "Disconnect Messenger?",
    disconnectBody: "The assistant stops replying on {{page}}. Messages go to your Page inbox only. You can reconnect any time.",
    disconnectConfirm: "Disconnect Messenger",
    disconnected: "Messenger disconnected",
    thisPage: "your Page",
  },
  email: {
    description: "Forward your mailbox here. The assistant drafts replies for staff review, or auto-replies to simple questions.",
    inboundLabel: "Inbound address",
    copyInbound: "Copy inbound address",
    copied: "Inbound address copied",
    replyMode: "Email reply mode",
    modeDraft: "Draft for review",
    modeAuto: "Auto-reply",
    modeSaved: "Email mode: {{mode}}",
    setUp: "Set up inbox",
    settings: "Inbox settings",
    settingsTitle: "Email inbox",
    settingsBody: "We'll create an inbound address for this assistant. Forward your mailbox to it.",
    forwarding: "Your mailbox",
    forwardingHint: "Shown to staff so they know which mailbox forwards here.",
    forwardingPlaceholder: "e.g. hello@example.com",
    forwardingInvalid: "Enter a valid email address",
    save: "Save inbox",
    saved: "Email inbox saved",
  },
  api: {
    keys_one: "{{count}} key active",
    keys_other: "{{count}} keys active",
    noKeys: "No keys yet",
    description: "Build your own interface. Answers come back as JSON with citations, or stream as Server-Sent Events.",
    keysLink: "API keys",
  },
  webhooks: {
    title: "Webhooks",
    endpoints_one: "{{count}} endpoint",
    endpoints_other: "{{count}} endpoints",
    none: "No endpoints",
    description: "Send events such as new leads and handoffs to your own systems.",
    manage: "Manage",
  },
  comingSoon: {
    badge: "Coming soon",
    viber: "Viber",
    viberBody: "Viber Business Messages for people who prefer Viber.",
    note: "We'll announce these in the console when they launch.",
  },
  performance: {
    title: "Channel performance",
    period: "{{start}} – {{end}} · {{agent}}",
    range: "Performance range",
    days7: "7 days",
    days30: "30 days",
    colChannel: "Channel",
    colConversations: "Conversations",
    colResolution: "Resolution rate",
    colResponse: "Avg response",
    colCsat: "CSAT",
    resolutionLabel: "{{channel}} resolution rate",
    emptyTitle: "No channel activity yet",
    emptyBody: "Turn on a channel and share it — performance shows up after the first conversations.",
    loadError: "Channel performance couldn't load.",
    noAccess: "You need analytics access to see channel performance.",
  },
  errors: {
    notConfigured: "Facebook sign-in isn't configured for this platform yet. Contact support.",
  },
} as const;
